import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import KeyboardArrowLeftRoundedIcon from '@mui/icons-material/KeyboardArrowLeftRounded';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import { useCallback, useState } from 'react';
import { createChooseUsernameOutbound } from '../../api/outbound/entryOutbounds';
import { useInstanceId } from '../../context/instance/instanceContext';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
import { setGameEntryActionPending, switchToLogin } from '../../redux/actions/gameEntryActions';
import { addMessageBox } from '../../redux/actions/messageBoxesActions';
import { useAppDispatch, useAppSelector } from '../../redux/store';
import { Form } from '../../styles/styles';
import { getPrefillEmailFromUrl, getPrefillPasswordFromUrl, getPrefillUsernameFromUrl } from '../../utils/utils';
import { EntryPanel } from './entryPanel';
export const SignUpPanel = () => {
    const isActionPending = useAppSelector((state) => state.gameEntry.isActionPending);
    const isSignUpAgreementConfirmed = useAppSelector((state) => state.gameEntry.isSignUpAgreementConfirmed);
    const socketSend = useSocketSend();
    const instanceId = useInstanceId();
    const [username, setUsername] = useState(getPrefillUsernameFromUrl(instanceId));
    const [password, setPassword] = useState(getPrefillPasswordFromUrl(instanceId));
    const [email, setEmail] = useState(getPrefillEmailFromUrl(instanceId));
    const dispatch = useAppDispatch();
    const handleUsernameChange = useCallback((event) => {
        setUsername(event.target.value);
    }, []);
    const handlePasswordChange = useCallback((event) => {
        setPassword(event.target.value);
    }, []);
    const handleEmailChange = useCallback((event) => {
        setEmail(event.target.value);
    }, []);
    const handleSignUpClick = useCallback((event) => {
        event.preventDefault(); // prevents reloading the page when in a form
        dispatch(setGameEntryActionPending(true));
        if (isSignUpAgreementConfirmed) {
            socketSend(createChooseUsernameOutbound(username, password, email));
        }
        else {
            dispatch(addMessageBox({ type: 'sign-up-confirmation', username, password, email }));
        }
    }, [dispatch, isSignUpAgreementConfirmed, socketSend, username, password, email]);
    const handleSwitchToLoginClick = useCallback(() => {
        dispatch(switchToLogin());
    }, [dispatch]);
    const isSignUpButtonDisabled = isActionPending || !username || !password || !email;
    return (_jsxs(EntryPanel, { title: 'Sign Up', ariaLabel: 'sign up panel', children: [_jsxs(Form, { children: [_jsx(TextField, { id: `sign-up-username-${instanceId}`, type: 'text', variant: 'filled', fullWidth: true, label: 'Choose Username', value: username, onChange: handleUsernameChange, size: 'small' }), _jsx(TextField, { id: `sign-up-password-${instanceId}`, type: 'password', variant: 'filled', fullWidth: true, label: 'Choose Password', value: password, onChange: handlePasswordChange, size: 'small' }), _jsx(TextField, { id: `sign-up-email-${instanceId}`, type: 'text', variant: 'filled', fullWidth: true, label: 'Email', value: email, onChange: handleEmailChange, size: 'small' }), _jsx(Button, { onClick: handleSignUpClick, disabled: isSignUpButtonDisabled, variant: 'contained', size: 'large', color: 'secondary', type: 'submit' // may help to invoke 'save password' prompts
                        , endIcon: isActionPending ? _jsx(CircularProgress, { size: 20, color: 'inherit' }) : undefined, children: "Sign Up" })] }), _jsx(Button, { onClick: handleSwitchToLoginClick, disabled: isActionPending, variant: 'contained', startIcon: _jsx(KeyboardArrowLeftRoundedIcon, {}), children: "Back to Login" })] }));
};
